// src/pages/letters/Edit.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../../core/api';
import '../factors/Factors.css';
import LetterForm, {
  emptyForm,
  buildPayload,
  validateForm,
  emptyCopy,
  discardUnsavedAttachments,
} from './LetterForm';
import LetterFormSkeleton from './LetterFormSkeleton';

const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState(emptyForm);
  const [serial, setSerial] = useState('');
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');
  const isDirtyRef = useRef(false);
const savedAttachmentsRef = useRef([]);

  const [uploading, setUploading] = useState(false);


  const show = (text, type = 'success') => {
    setMessage(text);
    setMessageType(type);
  };

 /* ============== Fetch ============== */
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get(`/letters/${id}`);
        const l = res.data?.letter;
        if (!l) {
          if (!cancelled) setNotFound(true);
          return;
        }
        if (cancelled) return;

        const copies = (l.copies || []).map((c) => ({
          name: c.name || '',
          position: c.position || '',
        }));

        setSerial(l.serial);
        savedAttachmentsRef.current = l.attachments || [];

        setForm({
          date: l.date || '',
          recipientName: l.recipientName || '',
          recipientPosition: l.recipientPosition || '',
          subject: l.subject || '',
          body: l.body || '',
          hasCopies: copies.length > 0,
          copies: copies.length ? copies : [emptyCopy()],
          signerName: l.signerName || '',
signerPosition: l.signerPosition || '',
attachments: l.attachments || [],
        });
      } catch (err) {
        if (cancelled) return;
        if (err.response?.status === 404) setNotFound(true);
        else show('خطا در دریافت اطلاعات نامه', 'danger');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id]);

  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => setMessage(''), 3000);
    return () => clearTimeout(t);
  }, [message]);

  useEffect(() => {
    const handler = (e) => {
      if (!isDirtyRef.current) return;
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, []);
const cancel = async () => {
  await discardUnsavedAttachments(form.attachments, savedAttachmentsRef.current);
  isDirtyRef.current = false;
  navigate('/dashboard/letters');
};
  const markDirty = () => {
    isDirtyRef.current = true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
if (uploading) {
  show('تا پایان آپلود پیوست صبر کنید', 'danger');
  return;
}

    const err = validateForm(form);
    if (err) {
      show(err, 'danger');
      return;
    }

    setSaving(true);
    try {
      await api.post(`/letters/${id}/edit`, buildPayload(form));
      isDirtyRef.current = false;
      show('تغییرات ذخیره شد', 'success');
      setTimeout(() => navigate('/dashboard/letters'), 800);
    } catch (error) {
      console.error('خطا در ذخیره نامه:', error);
      show(error.response?.data?.error || 'خطا در ذخیره تغییرات', 'danger');
    } finally {
      setSaving(false);
    }
  };

if (loading) return <LetterFormSkeleton />;
  if (notFound) {
    return (
      <div className="card">
        <h2>نامه یافت نشد</h2>
        <p className="empty">نامه‌ای با این شناسه وجود ندارد یا حذف شده است.</p>
        <div className="flexend">
          <Link className="btn secondary" to="/dashboard/letters">
            <i className="fa-solid fa-arrow-right" /> بازگشت به لیست
          </Link>
        </div>
      </div>
    );
  }

  return (
    <>
      {message && (
        <div className={messageType === 'danger' ? 'toast-danger' : 'toast-success'}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <LetterForm form={form} setForm={setForm} serial={serial} onDirty={markDirty} onMessage={show}  onUploadingChange={setUploading}  />
        <div className="flexend">
         <button type="button" className="btn secondary" onClick={cancel} disabled={uploading || saving}>
  <i className="fa-solid fa-xmark" /> انصراف
</button>
<button className="btn" type="submit" disabled={saving || uploading}>
  {!saving && !uploading && <i className="fa-solid fa-floppy-disk" />}
  {uploading ? 'در حال آپلود پیوست...' : saving ? 'در حال ذخیره...' : 'ثبت نامه'}
</button>
        </div>
      </form>
    </>
  );
};

export default Edit;